import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface IWrapperProps {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}

const _Wrapper: React.ForwardRefRenderFunction<HTMLDivElement, IWrapperProps> = (props, ref) => {
  const { className, children } = props;

  return (
    <div ref={ref} className={cx(styles['container'], className)}>
      {children}
    </div>
  );
};

export const Wrapper = React.forwardRef(_Wrapper);
